import { getModule } from 'vuex-module-decorators'
import store from '@/store'
import UserService from '@/services/UserService'
import SettingService from '@/services/SettingService'
import UserInfo from '@/store/modules/UserInfo'
import Setting from '@/store/modules/Setting'
import i18n from '@/lang'
import {
  getUnreadCount,
  getLikeCount,
  getFavouriteCount
} from '@/helpers/GetNotificationCount'

const UserModule = getModule(UserInfo, store)
const SettingModule = getModule(Setting, store)

let inflight: Promise<void> | null = null
/** Access token for which post-login bootstrap has already completed successfully. */
let bootstrapCompletedForToken: string | null = null

/**
 * Loads user info, profile, settings, and header notification counts once per login
 * (per access token). Dedupes concurrent calls via `inflight`.
 */
export function loadAuthenticatedSessionData(): Promise<void> {
  const token = store.state.auth.token
  if (!token) {
    bootstrapCompletedForToken = null
    return Promise.resolve()
  }
  const tokenKey = String(token)
  if (bootstrapCompletedForToken === tokenKey) {
    return Promise.resolve()
  }
  if (inflight != null) {
    return inflight
  }
  const run = (async () => {
    await Promise.all([
      UserService.getUserInfo()
        .then(res => {
          if (res.status === 200) {
            UserModule.HANDLE_USER_INFO(res.data)
          }
        })
        .catch(err => {
          console.log(err)
        }),
      UserService.getUserProfile()
        .then(res => {
          if (res.status === 200) {
            UserModule.HANDLE_USER_PROFILE(res.data)
          }
        })
        .catch(err => {
          console.log(err)
        }),
      SettingService.getUserSetting()
        .then(res => {
          if (res.status === 200) {
            SettingModule.HANDLE_USER_SETTING(res.data)
            i18n.locale = store.state.setting.setting.setting_language.code
          }
        })
        .catch(err => {
          console.log(err)
        }),
      getUnreadCount(),
      getFavouriteCount()
    ])
  })()
  inflight = run.finally(() => {
    inflight = null
    const stillSame =
      store.state.auth.token && String(store.state.auth.token) === tokenKey
    const uid = store.state.userInfo.user.info.id
    const hasUserId = uid !== '' && uid != null
    if (stillSame && hasUserId) {
      bootstrapCompletedForToken = tokenKey
    }
  })
  return inflight
}
